module.exports = {
      id: "menu-search-usage",
      viewBox: "0 0 28.943 16.863",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#menu-search",
      toString: function () {
        return this.url;
      }
    }